export function findFromBrands(name, providedArray) {
  return providedArray?.find(channel => {
    if (channel.name === name) return true;
    if (channel.brands) return findFromBrands(name, channel.brands);
    return false;
  });
}
